import { Alert, Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatCurrency } from '@/utils/helper';

/** @param {import("prop-types").InferProps<typeof StepConfirmationPropTypes>} props */
export default function StepConfirmation({
  confirmationInfo = null,
  paymentStatus = null,
  resetForm,
}) {
  const { t, i18n } = useTranslation();

  return (
    <Box>
      <Typography gutterBottom variant="h5">
        {t('donation.confirmation')}
      </Typography>

      {paymentStatus === 'success' && confirmationInfo && (
        <Alert severity="success" sx={{ my: 2 }}>
          🎉 {t('donation.thanks')} {confirmationInfo.username || ''}!
          <br />
          {t('donation.amount')} : {formatCurrency(confirmationInfo.amount, i18n.language, true)}
          <br />
          {t('donation.receipt')} : {confirmationInfo.chargeId}
          <br />
          {t('donation.timestamp')} : {new Date(confirmationInfo.timestamp).toLocaleString()}
        </Alert>
      )}

      {paymentStatus === 'error' && (
        <Alert severity="error" sx={{ my: 2 }}>
          {t('donation.error.capture')}
        </Alert>
      )}

      <Box sx={{ display: 'flex', gap: 2, marginTop: 4 }}>
        <Button variant="outlined" href="/">
          {t('donation.home')}
        </Button>
        <Button variant="contained" onClick={resetForm}>
          {t('donation.new')}
        </Button>
      </Box>
    </Box>
  );
}

const StepConfirmationPropTypes = {
  confirmationInfo: PropTypes.shape({
    username: PropTypes.string,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string,
    chargeId: PropTypes.string,
    timestamp: PropTypes.string,
  }),
  /* eslint-disable-next-line react/no-unused-prop-types
  -- Unused, but required for consistent steps interface */
  formData: PropTypes.any,
  paymentStatus: PropTypes.string,
  resetForm: PropTypes.func.isRequired,
};
StepConfirmation.propTypes = StepConfirmationPropTypes;
